/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum PremiumPaywallScene {
  // Create a new space
  AddSpace,
  // New model experience
  NewModel,
  // paid user template
  ProTemplate,
  // Add space member
  AddSpaceMember,
  // collaboration
  Collaborate,
  // Cross-spatial resource replication
  CopyResourceCrossSpace,
  // Publish to API or SDK
  API,
  // Add Timbre Resources
  AddVoice,
  // real-time voice conversation
  RTC,
  // export log
  ExportLog,
  // query log
  FilterLog,
}
export function useBenefitAvailable(_props: unknown) {
  return true;
}
const voidFunc = () => {
  console.log('unImplement void func');
};
export function usePremiumPaywallModal(_props: unknown) {
  return {
    node: <></>,
    open: voidFunc,
    close: voidFunc,
  };
}
